import React from 'react';

const templates = [
  { id: 'hearts', label: '❤️ Hearts' },
  { id: 'flowers', label: '🌸 Flowers' },
  { id: 'saturn', label: '🪐 Saturn' },
  { id: 'buddha', label: '🧘 Buddha' },
  { id: 'fireworks', label: '🎆 Fireworks' }
];

export default function ControlsPanel({ template, color, onTemplateChange, onColorChange, isCameraActive }) {
  const handleCameraToggle = () => {
    if (isCameraActive) {
      window.stopCamera?.();
    } else {
      window.startCamera?.();
    }
  };

  return (
    <div className="controls-panel">
      <div className="control-group">
        <h3>Shape</h3>
        <div className="template-buttons">
          {templates.map(t => (
            <button
              key={t.id}
              className={`template-btn ${template === t.id ? 'active' : ''}`}
              onClick={() => onTemplateChange(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="control-group">
        <h3>Color</h3>
        <input
          type="color"
          id="color-picker"
          value={color}
          onChange={(e) => onColorChange(e.target.value)}
        />
      </div>

      <div className="control-group">
        <h3>Instructions</h3>
        <div className="info-text">
          <p><strong>Gesture Control:</strong></p>
          <p>✊ <strong>Closed fist</strong> → Particles shrink</p>
          <p>👋 <strong>Open hand</strong> → Particles expand</p>
          <p>🖐️ <strong>Both hands</strong> → Average of both</p>
          <p>📹 Camera access required</p>
        </div>
        <button
          id="start-camera-btn"
          className={`start-camera-btn ${isCameraActive ? 'camera-active' : ''}`}
          onClick={handleCameraToggle}
        >
          <span className="camera-icon">{isCameraActive ? '■' : '▶'}</span>
          {isCameraActive ? 'Stop Camera' : 'Start Camera'}
        </button>
      </div>
    </div>
  );
}

